import { defineMessages } from 'react-intl';

export default defineMessages({
	kbCategorySectionTitle: {
		defaultMessage: 'Learn more about',
		description: 'Section title for a section that shows a list of knowledge base categories',
		id: 'cv.portal.home.kb.category.section.title',
	},
});
